import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '../store'
import { getToken, removeToken } from './cookie'
import router from '../router'

// create an axios instance
const service = axios.create({
  headers: {
    'Content-Type': 'application/json'
  },
  baseURL: process.env.VUE_APP_BASE_API,
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    config.data = JSON.stringify(config.data)
    if (store.state.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const { code, msg } = response.data
    let { data } = response.data
    const myCode = Number(code)
    if (myCode === 100 || myCode === 110) {
      if (myCode === 110) {
        Message({
          message: msg || '成功',
          type: 'success',
          duration: 3000
        })
      }
      if (data === '') {
        data = '成功'
      }
      return data
    } else if (myCode === 200 || myCode === 400) {
      Message({
        message: msg || '错误',
        type: 'error',
        offset: 120,
        duration: 3000
      })
      if (msg === '请重新登录') {
        removeToken()
        store.commit('setUserData', '')
        router.push('/login')
      }
      if (myCode === 400 || msg === '请重新登录') {
        removeToken()
        store.commit('setUserData', '')
        router.push('/')
      }
    } else if (myCode === 210 || myCode === 401) {
      MessageBox.confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (myCode === 401) {
          router.push('/')
        }
      })
    }
  },
  error => {
    if (error.message === 'Network Error') {
      error.message = '网络错误'
    }
    if (error.message !== 'Request aborted') {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }

    return Promise.reject(error)
  }
)

export default service
